const icon = require('vue-svgicon');
icon.register({
    'success': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M 12.055 25.954 L 29.853 8.255 C 30.347 7.763 30.347 6.964 29.853 6.473 C 29.358 5.981 28.557 5.981 28.062 6.473 L 11.075 23.363 L 4.349 16.673 C 3.855 16.181 3.054 16.181 2.563 16.673 C 2.069 17.165 2.069 17.96 2.563 18.449 L 10.09 25.937 C 10.106 25.955 10.11 25.977 10.116 26 C 10.122 26.024 10.126 26.05 10.146 26.069 C 10.406 26.327 10.746 26.434 11.085 26.421 C 11.418 26.43 11.754 26.32 12.009 26.066 C 12.025 26.049 12.029 26.029 12.033 26.007 C 12.037 25.988 12.042 25.97 12.055 25.954 Z" _fill="#000"/>`,
    },
});
